import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, DisabledPrompt, useBCMSContext, useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { FormRowView, PageContainer, PageContentView, WidgetContainer, WidgetView } from 'components/shared';
import { PrimaryButton, SecondaryButton } from 'components/ui';
import Classes from "model";
import React from 'react';
import TASPositivePayAddChecksPageCheckForm from "./classes/TASPositivePayAddChecksPageCheckForm";
import TASPositivePayAddChecksDesktopView from "./components/TASPositivePayAddChecksDesktopView";
import TASPositivePayAddChecksMobileView from "./components/TASPositivePayAddChecksMobileView";
import "./styles.css";
import "./mobile.css";


/**
 * @function TASPositivePayAddChecksPage
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay Add Check page.
 */
export default function TASPositivePayAddChecksPage(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = { ...getDefaultData(undefined, context), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    onChange: (id, prop, setVal) => val => {
      var editCheckForms = state.data.editCheckForms;
      var index = editCheckForms.findIndex(item => item.id === id);
      var selectedCheckForm = editCheckForms[index];
      var checkForm = TASPositivePayAddChecksPageCheckForm.init({ ...selectedCheckForm.record });

      if(prop === "amount") {
        checkForm[prop] = val.amount;
      } else {
        checkForm[prop] = setVal ? setVal : val;
      }
  
      editCheckForms.splice(index, 1, checkForm);

      BCMSStateManagerCRUD.init(state)
      .update([ "data", "editCheckForms"], editCheckForms)
      .submit(setState);
    },

    onMobileSave: (id, stateEditCheckForms) => val => {
      var editCheckForms = stateEditCheckForms;
      var index = editCheckForms.findIndex(item => item.id === id);
      var selectedCheckForm = editCheckForms[index];
      var checkForm = TASPositivePayAddChecksPageCheckForm.init({ ...selectedCheckForm.record });
      var defaultPositivePayCheck = BCMSDefaultModel.positivePayCheck();
      checkForm = BCMSDefaultModel.mergeRecords(checkForm.record, defaultPositivePayCheck.record);
      checkForm = TASPositivePayAddChecksPageCheckForm.init({ ...checkForm });
      checkForm["mobileViewIsEditing"] = false;
      editCheckForms.splice(index, 1, checkForm);

      BCMSStateManagerCRUD.init(state)
      .update([ "data", "editCheckForms"], editCheckForms)
      .submit(setState);
    }
  });

  return (
    <PageContainer className="tas-positive-pay-add-check-page" state={ { data, ui } } controller={ controller }>
      <PageContent />
    </PageContainer>
  );
}

export const getDefaultData = () => {
  var checkForm = TASPositivePayAddChecksPageCheckForm.init();
  const checkForms = [checkForm];

  return {
    // Forms to edit (may not be saved or submitted).
    editCheckForms: checkForms, 
    // Forms to submit (after editing and saving).
    //submitCheckForms: checkForms, 
  }
};

export const getDefaultUI = () => {
  var checkForm = TASPositivePayAddChecksPageCheckForm.init();

  return {
    accountSelect: { isActive: false },
    cancelModal: { isActive: false },
    editCheckForms: [ 
      { id: checkForm.id, issuedDate: { isActive: false }, type: { isActive: false } } 
    ], 
  };
};

function PageContent(props) {
  const { data, ui } = useStateManager();

  return (
    <PageContentView>
         <WidgetContainer className="tas-positive-pay-add-check-widget">
            <WidgetView text="Add Checks">
              <div className="flex-container flex-horizontal account-select-section-container">
                <div className="set-width account-select-container">
                    <FormRowView text="Account">
                        <CustomSelect active={ ui.accountSelect.isActive }>
                            <CustomSelectItem value="prompt"></CustomSelectItem>
                        </CustomSelect>
                    </FormRowView>
                </div>
                <div className="flex-width"></div>
              </div>
              { <TASPositivePayAddChecksDesktopView edit={ { editCheckForms: data.editCheckForms } }
              cancelModal={ ui.cancelModal } /> }
              { <TASPositivePayAddChecksMobileView edit={ { editCheckForms: data.editCheckForms } }
              cancelModal={ ui.cancelModal } /> }
              <div className="flex-container flex-horizontal links-container">
                <DisabledPrompt>
                  <a className="set-width clickable">Add More Checks</a>
                </DisabledPrompt>
              </div>
              <div className="flex-container flex-horizontal button-container">
                <div className="set-width secondary-button-container disabled">
                    <SecondaryButton text="Review Submitted Check(s)" onClick={ undefined } />
                </div>
                  <div className="set-width">
                    <DisabledPrompt>
                      <PrimaryButton className="set-width" text="Submit" data-point="Search_Button" onClick={ undefined } />
                    </DisabledPrompt>
                  </div>
              </div>
            </WidgetView>
        </WidgetContainer>
    </PageContentView>
  );
}